// frontend/modules/customer-category/routes.tsx
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import CustomerCategoryManagementView from './views/CustomerCategoryManagementView';
import CustomerCategoryCreateView from './views/CustomerCategoryCreateView';
import CustomerCategoryEditView from './views/CustomerCategoryEditView';
import CustomerCategoryDetailView from './views/CustomerCategoryDetailView';
import FieldConfigurationView from './views/FieldConfigurationView';
import CustomerOnboardingView from './views/CustomerOnboardingView';

export const customerCategoryRoutes: RouteObject[] = [
    {
        path: '/admin/general-config/customer-categories',
        element: <CustomerCategoryManagementView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/admin/general-config/customer-categories/create',
        element: <CustomerCategoryCreateView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/customer-categories',
        element: <CustomerCategoryManagementView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/customer-categories/create',
        element: <CustomerCategoryCreateView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/admin/general-config/customer-categories/:id',
        element: <CustomerCategoryDetailView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/admin/general-config/customer-categories/:id/edit',
        element: <CustomerCategoryEditView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/admin/general-config/field-configurations',
        element: <FieldConfigurationView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/customers/individual',
        element: <CustomerOnboardingView />,
        errorElement: <ErrorBoundary />
    }
];